import { EmpresasList } from '../Empresas/EmpresasList';

/**
 * Pagina de transportistas efectivos. Filtra Empresas con tipo='TRANSPORTISTA'.
 *
 * Hereda toda la logica del componente generico `EmpresasList` (alta,
 * listado, busqueda, validacion). Solo cambian los textos de UI.
 */
export function TransportistasList() {
  return (
    <EmpresasList
      tipo="TRANSPORTISTA"
      titulo="Transportistas efectivos"
      subtitulo="Empresas que realizan el transporte."
      botonNuevo="Nuevo transportista"
      tituloModal="Nuevo transportista efectivo"
      exitoTitulo="Transportista dado de alta"
      emptyHint="No hay transportistas. Da de alta el primero con el boton de arriba."
      errorTitulo="No se pudieron cargar los transportistas"
    />
  );
}
